import image1 from "../assets/t-image1.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I've been a member of this gym for over a year now, and I can confidently say it's the best decision I've made for my health and well-being. The staff is exceptional, always ready to provide guidance and support whenever needed",
    name: 'MARY ANNE',
    status : 'Premium Member'
  },
  {
    image: image2,
    review: 'As someone who was initially hesitant about going to the gym, I am so grateful to have found this place.The classes are dynamic and fun, offering a great mix of strength training and cardio exercises. ',
    name: 'JAMES RYAN',
    status: 'Premium Member'
  },
  {
    image : image3,
    review:"What sets this gym apart is the range of amenities available, from the spacious weightlifting area to the wide selection of cardio machines. The sense of community here is fantastic, and I've made some great friends along the way. " ,
    name: 'MELANIE',
    status: "Standard Member"
  }
];
